/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import _ from 'underscore';

import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';
import { forTemplate } from '@trello/i18n';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import {
  getKey,
  Key,
  registerShortcutHandler,
  Scope,
  unregisterShortcutHandler,
} from '@trello/keybindings';

import { getCardUrl } from 'app/scripts/controller/urls';
import { CardCopyView } from 'app/scripts/views/card/CardCopyView';
import { toggleCardCoverChooserPopover } from 'app/scripts/views/card/CardCoverChooserPopover';
import { CardMemberSelectView } from 'app/scripts/views/card/CardMemberSelectView';
import { CardMoveView } from 'app/scripts/views/card/CardMoveView';
import { CardViewHelpers } from 'app/scripts/views/card/CardViewHelpers';
import { renderDueComplete } from 'app/scripts/views/card/CardViewPlugins';
import { trackSeparator } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { StickerEditView } from 'app/scripts/views/stickers/StickerEditView';
import { QuickCardEditorTemplate } from 'app/scripts/views/templates/QuickCardEditorTemplate';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { LazyCardDateRangePicker } from 'app/src/components/DateRangePicker/LazyCardDateRangePicker';
import { toggleLabelsPopover } from 'app/src/components/LabelsPopover';
import { ConvertCardRoleButton } from 'app/src/components/QuickCardEditor';
import { defaultRouter } from 'app/src/router';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import {
  clearColorCover,
  clearCover,
  clearFullCover,
  getBadgesHtml,
  getFullCoverStylesForInitialRender,
  labelsData,
  renderBadges,
  renderCover,
  renderFullCover,
  renderLabels,
  renderMembers,
  renderPluginCover,
  toggleDueDateComplete,
  updateBadges,
  updateCheckItemsEarliestDue,
  updateDateBadges,
  updateDueDate,
} from './CardViewMixins';

const format = forTemplate('due_date_picker');

/**
 * The Edit Labels popover was rewritten under the assumption that it would only
 * be opened in the context of a board. We were totally unaware that this
 * view could be opened from within My Cards (only after sorting by due date),
 * and the experience would be completely broken there.
 *
 * This is an explicit allowlist for screens on which the Edit Labels button can
 * be rendered. Refactoring the labels popover to accommodate this use case is
 * not really viable considering the low usage of this view on other screens:
 * https://analytics.amplitude.com/atlassian/chart/gzncrgb
 */
const VALID_SCREENS_FOR_EDIT_LABELS = ['boardScreen', 'cardDetailScreen'];

class QuickCardEditorView extends View {
  static initClass() {
    this.prototype.className = 'quick-card-editor';
    this.prototype.isMouseDownOnOverlay = false;

    this.prototype.renderDueComplete = renderDueComplete;

    this.prototype.events = {
      'keydown .js-edit-card-title': 'quickCardEditKeydown',
      'click .js-save-edits': 'saveEdits',

      'click .js-stop': 'stopCard',

      'click .js-edit-labels': 'editLabels',
      'click .js-edit-members': 'editMembers',
      'click .js-edit-cover': 'editCover',
      'click .js-move-card': 'moveCard',
      'click .js-copy-card': 'copyCard',
      'click .js-edit-due-date': 'editDueDate',
      'click .js-archive': 'archive',
      'click .js-due-date-badge': 'toggleDueDateComplete',

      click: 'checkCloseEditor',
      'click .js-close-editor': 'closeEditor',

      mousedown: 'mousedownOnOverlay',
    };

    this.prototype.clearCover = clearCover;
    this.prototype.clearColorCover = clearColorCover;
    this.prototype.renderCover = renderCover;
    this.prototype.clearFullCover = clearFullCover;
    this.prototype.renderFullCover = renderFullCover;
    this.prototype.getFullCoverStylesForInitialRender = getFullCoverStylesForInitialRender;
    this.prototype.renderPluginCover = renderPluginCover;
    this.prototype.getBadgesHtml = getBadgesHtml;
    this.prototype.renderBadges = renderBadges;
    this.prototype.updateDateBadges = updateDateBadges;
    this.prototype.updateDueDate = updateDueDate;
    this.prototype.updateCheckItemsEarliestDue = updateCheckItemsEarliestDue;
    this.prototype.toggleDueDateComplete = toggleDueDateComplete;
    this.prototype.updateBadges = updateBadges;
    this.prototype.renderMembers = renderMembers;
    this.prototype.labelsData = labelsData;
    this.prototype.renderLabels = renderLabels;
  }

  constructor(options) {
    super(options);
    this.onShortcut = this.onShortcut.bind(this);
    registerShortcutHandler(this.onShortcut, { scope: Scope.Overlay });
  }

  static open(cardView) {
    this.close();

    const { $el } = cardView;
    const offset = $el.offset();

    const opts = {
      width: $el.width(),
      left: offset.left,
      top: offset.top,
      onMap: cardView.onMap,
      showEditLabels: VALID_SCREENS_FOR_EDIT_LABELS.includes(
        getScreenFromUrl(),
      ),
    };

    Analytics.sendScreenEvent({
      name: 'quickCardEditorInlineDialog',
      attributes: {
        view: getScreenFromUrl(),
      },
    });

    return (this.current = new QuickCardEditorView({
      model: cardView.model,
      modelCache: cardView.modelCache,
      onRemove: () => {
        this.current = null;
      },
    }).render(opts));
  }

  static close() {
    if (this.current != null) {
      this.current.closeEditor();
    }
    return (this.current = null);
  }

  initialize() {
    this.makeDebouncedMethods(
      'render',
      'renderStickers',
      'renderLabels',
      'renderCover',
      'renderBadges',
      'updateBadges',
      'rerender',
    );

    // We need to subscribe this onRouteChanged function to the router
    // so we would know when a user is navigating away from the page
    // where this was initialized. Otherwise the quick editor would
    // still be open regardless of the page the user navigates to.
    //
    // Specifically if they come to the board from the board list.
    // Without this subscription, after they hit the back button
    // the quick editor would sit on top of the board list page.
    this.unsubscribeFromRouter = defaultRouter.subscribe(
      this.onRouteChanged.bind(this),
    );
    this.routeWhenOpened = defaultRouter.getRoute().routePath;

    this.listenTo(this.model, {
      'change:labels': this.renderLabelsDebounced,
      'change:idLabels': this.renderLabelsDebounced,
      'change:idAttachmentCover': this.renderCoverDebounced,
      'change:cover': this.renderCoverDebounced,
      'change:dueComplete': this.renderDueComplete,
      'change:due change:subscribed change:isTemplate': this
        .renderBadgesDebounced,
      'change:badges': this.updateBadgesDebounced,
      'change:cardRole': this.rerenderDebounced,
    });

    this.listenTo(this.model.labelList, 'add remove reset change', () => {
      return this.renderLabelsDebounced();
    });

    this.listenTo(
      this.model.memberList,
      'add remove reset',
      this.frameDebounce(this.renderMembers),
    );

    return this.listenTo(
      this.model.stickerList,
      'add remove reset change sort',
      function () {
        return this.renderStickersDebounced();
      },
    );
  }

  onTracedUpdate(opts) {
    const { traceId, taskName, field } = opts;
    return (err, card) => {
      if (err) {
        throw Analytics.taskFailed({
          taskName,
          traceId,
          source: 'quickCardEditorInlineDialog',
          error: err,
        });
      } else {
        Analytics.sendUpdatedCardFieldEvent({
          field,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: card.id },
            board: { id: card.idBoard },
            list: { id: card.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
          attributes: {
            taskId: traceId,
          },
        });
        Analytics.taskSucceeded({
          taskName,
          traceId,
          source: 'quickCardEditorInlineDialog',
        });
      }
    };
  }

  shouldRenderFullCover() {
    return false;
  }

  onRouteChanged(routeContext) {
    // Backbone will fire this function once when the editor is opened
    // this conditional is here just to prevent the editor from instantly closing.
    if (routeContext.routePath !== this.routeWhenOpened) {
      return this.closeEditor();
    }
  }

  remove() {
    this.unsubscribeFromRouter();
    unregisterShortcutHandler(this.onShortcut);
    this.options.onRemove?.();
    return super.remove(...arguments);
  }

  showCover() {
    return this.model.getBoard().getPref('cardCovers') && this.model.hasCover();
  }

  showStickers() {
    return true;
  }

  onShortcut(event) {
    switch (getKey(event)) {
      case Key.Escape:
        this.closeEditor();
        Analytics.sendPressedShortcutEvent({
          shortcutName: 'closeEditorShortcut',
          keyValue: Key.Escape,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: this.model?.id },
            board: { id: this.model?.idBoard },
            list: { id: this.model?.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
        });
        return event.preventDefault();

      case Key.Enter:
        this.saveEdits();
        Analytics.sendPressedShortcutEvent({
          shortcutName: 'saveEditsShortcut',
          keyValue: Key.Enter,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: this.model?.id },
            board: { id: this.model?.idBoard },
            list: { id: this.model?.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
        });
        return event.preventDefault();

      default:
        break;
    }
  }

  render(opts) {
    this.opts = opts;

    const data = this.model.toJSON();
    data.labels = this.model.getLabels();
    data.showCover = this.showCover();
    data.hasStickers = this.model.hasStickers();
    data.cardUrl = getCardUrl(this.model);
    data.quickEdit = true;
    data.members = [];
    data.isTemplate = this.model.isOnBoardTemplate();
    data.isCardTemplate = !!this.model.get('isTemplate');
    data.cardRole = this.model.getCardRole();
    data.showEditLabels = opts.showEditLabels;

    // gotta position this thing
    data.left = this.cLeft = opts.left;
    data.top = this.cTop = opts.top;
    data.width = this.cWidth = opts.width;
    // 160 is the width of the controls, which are absolutely positioned
    const cRight = this.cWidth + this.cLeft + 160;
    const wWidth = $(window).width();

    // completely cover card on map
    if (opts.onMap) {
      data.top = data.top - 20;
    }

    if (cRight > wWidth) {
      data.leftButtons = true;
      this._usingLeftButtons = true;
    }

    this.$el.html(templates.fill(QuickCardEditorTemplate, data, {}));

    this.renderStickers();
    this.renderCover();
    this.renderLabels();
    this.renderBadges();
    this.renderMembers();
    this.checkShowCover();

    this.renderDueComplete();

    // view.remove() removes the editor from# the DOM, which happens every time
    // we close the editor, so this is okay.
    $('#chrome-container').append(this.$el);

    this.calcHeight();

    this.focusInput();

    this.defer(() => {
      return $('.quick-card-editor-buttons', this.$el).addClass('fade-in');
    });

    $('.js-edit-card-title', this.$el).autosize();

    renderComponent(
      React.createElement(ConvertCardRoleButton, {
        idCard: this.model.get('id'),
        onLoad: () => this.calcHeight(),
        analyticsContainers: this.model.getAnalyticsContainers(),
      }),
      this.el.querySelector('#convert-card-role-button-react-root'),
    );

    return this;
  }

  rerender() {
    this.render(this.opts);
  }

  calcHeight() {
    let top;
    const wHeight = $(window).height();

    // Might overflow the window height so lets make sure that doesn't happen.
    // This needs to happen here because it's in the DOM now and the
    // calculations will be right.
    const cHeight = $('.quick-card-editor-card', this.$el).outerHeight();
    if (this.cTop + cHeight > wHeight) {
      top = wHeight - cHeight - 8;
      $('.quick-card-editor-card', this.$el).css({ top });
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $buttons = $('.quick-card-editor-buttons', this.$el);
    const bHeight = $buttons.outerHeight();
    const bOffset = $buttons.offset();

    if (bHeight + bOffset.top > wHeight) {
      $buttons.css({ top: cHeight - bHeight });
    }
  }

  renderStickers() {
    // Don't re-render the stickers if we contain something that's in
    // the middle of an edit
    if ($('.sticker.moving, .sticker.rotating', this.$el).length > 0) {
      return this;
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $stickers = $('.js-card-stickers', this.$el).empty();
    const subviews = Array.from(this.model.stickerList.models).map((sticker) =>
      this.subview(StickerEditView, sticker, { card: this.model }),
    );
    this.appendSubviews(subviews, $stickers);

    $('.list-card', this.$el).toggleClass(
      'is-stickered',
      this.model.hasStickers(),
    );

    return this;
  }

  checkShowCover() {
    $('.list-card', this.$el)
      .toggleClass('is-covered', this.showCover())
      .toggleClass('is-stickered', this.model.hasStickers());

    return this;
  }

  focusInput() {
    return $('.js-edit-card-title', this.$el).focus().select();
  }

  showPopOver(e, viewClass, opts) {
    if (opts == null) {
      opts = {};
    }
    stopPropagationAndPreventDefault(e);

    PopOver.toggle({
      elem: $(e.target).closest('a'),
      view: new viewClass({
        model: this.model,
        modelCache: this.modelCache,
        ...opts,
      }),
      alignRight: this._usingLeftButtons,
    });
  }

  showDateRangePicker(e) {
    const elem = $('.js-card-menu', this.$el);
    if (elem) {
      return PopOver.toggle({
        elem: $(e.target).closest('a'),
        getViewTitle: () => format('dates'),
        keepEdits: true,
        reactElement: React.createElement(LazyCardDateRangePicker, {
          due: this.model.get('due'),
          start: this.model.get('start'),
          dueReminder: this.model.get('dueReminder'),
          hidePopover: () => PopOver.hide(),
          idCard: this.model.id,
          idBoard: this.model.getBoard()?.id,
          idOrg: this.model.getBoard()?.get('idOrganization'),
        }),
      });
    }
  }

  editLabels(e) {
    toggleLabelsPopover({
      idCard: this.model.id,
      source: 'quickCardEditorInlineDialog',
      triggerElement: $(e.target).closest('a')[0],
    });
  }

  editMembers(e) {
    return this.showPopOver(e, CardMemberSelectView, {
      source: 'quickCardEditorInlineDialog',
    });
  }

  editCover(e) {
    toggleCardCoverChooserPopover({
      elem: $(e.currentTarget, this.$el),
      cardId: this.model.id,
      traceSource: 'quickCardEditorInlineDialog',
    });
  }

  copyCard(e) {
    return this.showPopOver(e, CardCopyView, {
      onCopy: this.closeEditor.bind(this),
      source: 'quickCardEditorInlineDialog',
    });
  }

  editDueDate(e) {
    this.showDateRangePicker(e);
  }

  moveCard(e) {
    const onCommit = this.closeEditor.bind(this);
    return this.showPopOver(e, CardMoveView, {
      onCommit,
      source: 'quickCardEditorInlineDialog',
    });
  }

  archive(e) {
    stopPropagationAndPreventDefault(e);

    const traceId = Analytics.startTask({
      taskName: 'edit-card/closed',
      source: 'quickCardEditorInlineDialog',
    });

    this.model.close(
      traceId,
      this.onTracedUpdate({
        traceId,
        taskName: 'edit-card/closed',
        field: 'closed',
      }),
    );

    this.closeEditor();

    Analytics.sendTrackEvent({
      action: 'archived',
      actionSubject: 'card',
      source: 'quickCardEditorInlineDialog',
      containers: {
        card: { id: this.model?.id },
        board: { id: this.model?.idBoard },
        list: { id: this.model?.idList },
        organization: { id: this.model?.getBoard()?.get('idOrganization') },
      },
    });
  }

  quickCardEditKeydown(e) {
    if (getKey(e) === Key.Enter) {
      return this.saveEdits(e);
    }
  }

  saveEdits(e) {
    stopPropagationAndPreventDefault(e);

    const val = $('.js-edit-card-title', this.$el).val().trim();
    const currentVal = this.model.get('name');

    if (val === currentVal) {
      this.closeEditor();
    } else if (val !== '') {
      const traceId = Analytics.startTask({
        taskName: 'edit-card/name',
        source: 'quickCardEditorInlineDialog',
      });
      this.model.recordAction({
        type: 'rename',
        name: val,
        previousName: currentVal,
      });
      this.model.update(
        { name: val, traceId: traceId },
        this.onTracedUpdate({
          traceId,
          taskName: 'edit-card/name',
          field: 'name',
        }),
      );
      this.closeEditor();
      trackSeparator(val, {
        category: 'quick card editor',
        method: 'by editing name',
      });
    } else {
      $('.js-edit-card-title', this.$el).focus().select();
    }
  }

  mousedownOnOverlay(e) {
    this.isMouseDownOnOverlay = e.target === this.$el[0];
  }

  checkCloseEditor(e) {
    if (this.isMouseDownOnOverlay) {
      this.isMouseDownOnOverlay = false;

      if (PopOver.isVisible) {
        PopOver.hide();
      } else if ($('.sticker.editing', this.$el).length > 0) {
        this.stopEditingStickers();
      } else {
        this.closeEditor(e);
      }
    }
  }

  closeEditor(e) {
    this.remove();
    PopOver.hide();
    Analytics.sendClosedComponentEvent({
      componentName: 'quickCardEditorInlineDialog',
      componentType: 'inlineDialog',
      containers: {
        card: { id: this.model?.id },
        board: { id: this.model?.idBoard },
        list: { id: this.model?.idList },
        organization: { id: this.model?.getBoard()?.get('idOrganization') },
      },
      source: getScreenFromUrl(),
    });
  }

  stopEditingStickers() {
    for (const sticker of Array.from(_.clone(this.model.stickerList.models))) {
      sticker.trigger('stopEditing');
    }
  }

  stopCard(e) {
    e?.stopPropagation();
    PopOver.hide();
  }
}
QuickCardEditorView.initClass();

_.extend(QuickCardEditorView.prototype, CardViewHelpers);

export { QuickCardEditorView };
